import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Prestamos.css";

export default function Prestamos() {
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    folio: "",
    cliente: "",
    fecha: "",
    estatus_pago: "",
    estatus:"",
  });

  const prestamos = [
    {
      id: 101,
      cliente: "Juan Pérez",
      estatus: "Activo",
      estatus_pago: "Al corriente",
      fecha: "2026-02-15",
      tipo: "Diario",
      pagos: "4/12",
    },
    {
      id: 102,
      cliente: "María López",
      estatus: "Activo",
      estatus_pago: "Inconsistente",
      fecha: "2026-02-16",
      tipo: "Diario",
      pagos: "2/12",
    },
    {
      id: 103,
      cliente: "Carlos Ruiz",
      estatus: "Activo",
      estatus_pago: "Incumplido",
      fecha: "2026-02-17",
      tipo: "Diario",
      pagos: "0/12",
    },
  ];

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  return (
    <div className="prestamos-container">
      {/* 🔥 TÍTULO PRINCIPAL */}
      <div className="titulo-bar">
        <h1 className="titulo-principal">Préstamos</h1>
        <button className="btn-nuevo" onClick={() => navigate("/prestamos/crear")}>Nuevo Préstamo +</button>
      </div>

      {/* 🔥 SUBTÍTULO DE FILTROS */}
      <h2 className="subtitulo">Filtros</h2>

      {/* 🔥 Barra de filtros */}
      <div className="filtros-bar">
        <input
          type="text"
          name="folio"
          placeholder="Buscar por folio"
          value={filters.folio}
          onChange={handleChange}
        />

        <input
          type="text"
          name="cliente"
          placeholder="Buscar por cliente"
          value={filters.cliente}
          onChange={handleChange}
        />

        <input
          type="date"
          name="fecha"
          value={filters.fecha}
          onChange={handleChange}
        />

        <select name="estatus_pago" value={filters.estatus} onChange={handleChange}>
          <option value="">Estatus Pago</option>
          <option value="Al corriente">Al corriente</option>
          <option value="Inconsistente">Inconsistente</option>
          <option value="Incumplido">Incumplido</option>
        </select>
      </div>

      {/* 🔥 SUBTÍTULO DE TABLA */}
      <h2 className="subtitulo">Listado de préstamos activos</h2>
      {/* 🔥 Tabla */}
      <table className="prestamos-table">
        <thead>
          <tr>
            <th>ID-Préstamo</th>
            <th>Cliente</th>
            <th>Estatus</th>
            <th>Estatus Pago</th>
            <th>Fecha de creación</th>
            <th>Tipo de préstamo</th>
            <th>Pagos realizados</th>
          </tr>
        </thead>

        <tbody>
          {prestamos.map((p) => (
            <tr key={p.id}>
              <td>{p.id}</td>
              <td>{p.cliente}</td>
              <td>{p.estatus}</td>
              <td className={`estatus estatus-${p.estatus_pago.replace(" ", "").toLowerCase()}`}>
                {p.estatus_pago}
              </td>
              <td>{p.fecha}</td>
              <td>{p.tipo}</td>
              <td>{p.pagos}</td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
}